import { makeAutoObservable } from "mobx";
import { PDescription } from "./PDescription";
import { PModifierInstanceId } from "./PModifierInstanceId";
import { PPrice } from "./PPrice";
import { PTemporarilyUnavailableIngredients } from "./PTemporarilyUnavailableIngredients";
import { CreatorConfigValidation } from "./CreatorConfigValidation";
export class PModifierInstanceCreator {
    constructor(params) {
        this._isEditorVisibleOverride = null;
        this.instanceId = new PModifierInstanceId();
        this.domain = params.domain;
        this.modifierInstanceAvailabilityService =
            params.modifierInstanceAvailabilityService;
        this.modifierInstancePriceService = params.modifierInstancePriceService;
        this.modifierType = params.modifierType;
        this.localizationProvider = params.localizationProvider;
        this.creatorScopeProvider = params.creatorScopeProvider;
        this.packagingFeeTypes = params.packagingFeeTypes;
        this._sections = this.modifierType.sections.map((modifierItemSection) => params.pModifierSectionCreatorFactory.create({
            modifierItemSection,
            domain: params.domain,
            onChange: () => this.creatorConfigValidation.validate(),
            creatorScopeProvider: params.creatorScopeProvider,
        }));
        this.creatorConfigValidation = new CreatorConfigValidation({
            hasError: () => ["NotExpectedItems", "NotEnoughItems", "MaxItemsExceeded"].some((reason) => this.availability.unavailabilityReasons.includes(reason)),
            minItems: params.modifierType.domain.minItems,
            maxItems: params.modifierType.domain.maxItems,
        });
        makeAutoObservable(this);
    }
    get isVisible() {
        return this.sections.length > 0;
    }
    get isEditorHidden() {
        return this.domain.editorHidden || !this.isEditable;
    }
    get isEditable() {
        return this.domain.editability.isPossiblyEditable;
    }
    get isTogglingEditorPossible() {
        return this.isEditorHidden && this.isEditable;
    }
    get isEditorVisible() {
        var _a;
        if (!this.isEditable) {
            return false;
        }
        return (_a = this._isEditorVisibleOverride) !== null && _a !== void 0 ? _a : !this.domain.editorHidden;
    }
    toggleEditor() {
        this._isEditorVisibleOverride = !this.isEditorVisible;
    }
    get typeId() {
        return this.domain.typeId;
    }
    get name() {
        return this.modifierType.name;
    }
    get sections() {
        return this._sections.filter((section) => section.isVisible);
    }
    get price() {
        const p = new PPrice(this.localizationProvider, this.modifierInstancePriceService.price(this.domain.modifierInstance, this.creatorScopeProvider.parameterSet).spectrum).priceValue;
        return p === null ? "" : ` (${p})`;
    }
    get availability() {
        return this.modifierInstanceAvailabilityService.availability(this.domain.modifierInstance, this.creatorScopeProvider.parameterSet);
    }
    get selectedItemsDescription() {
        return PDescription.modifier(this.domain.modifierInstance, this.modifierType, this.packagingFeeTypes);
    }
    get description() {
        return this.modifierType.description;
    }
    get displayMode() {
        return this.modifierType.displayMode;
    }
    get temporarilyUnavailableIngredients() {
        const itemInstanceCreators = this._sections.flatMap((modifierSection) => modifierSection.allItemCreators);
        return PTemporarilyUnavailableIngredients.fromInstanceCreators(this.modifierType, itemInstanceCreators);
    }
    validate() {
        this.creatorConfigValidation.validate();
    }
}
